var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTxtBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.27 56.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_8As1U8",
    "data-name": "8As1U8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.45,56.87V.72C.66.56.8.37.92.38c9.23.25,18.51,0,27.65,1,9.52,1.05,14.71,9.57,12.25,18.37-1,3.38-2.65,5.36-6.45,7.77,2.16,2.05,5,3.85,6.56,6.4,3.48,5.58,2.31,17.39-7.32,21.17a21,21,0,0,1-7,1.74C18,57,9.35,56.87.45,56.87ZM12.32,32.53V47.64c4.08,0,8,.23,11.86-.06,4.3-.32,6.73-3.29,6.7-7.51,0-4.63-2.21-7.19-6.87-7.49C20.22,32.34,16.39,32.53,12.32,32.53Zm-.08-8.16c4.21-.24,8.2-.21,12.11-.75,3.49-.49,5.27-3,5.32-6.53s-1.49-6.16-4.76-6.66c-4.13-.63-8.35-.63-12.67-.91Z",
    transform: "translate(-0.45 -0.38)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTxtBold);
export default __webpack_public_path__ + "static/media/icon_txt_Bold.d8bdd541af2b223b19966209d332340d.svg";
export { ForwardRef as ReactComponent };